import React from 'react';
import { FaSpinner, FaTimes, FaCheck, FaCopy } from 'react-icons/fa';

const DuplicateAttributesModal = ({
  isOpen,
  onClose,
  onConfirm,
  isProcessing = false,
  sourceOggettoName,
  targetOggettoName,
  attributesCount = 0,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
              <FaCopy className="h-5 w-5 text-blue-600 dark:text-blue-400" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
              Duplicazione Attributi
            </h3>
          </div>
          <button
            onClick={onClose}
            disabled={isProcessing}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors disabled:opacity-50"
          >
            <FaTimes className="h-5 w-5" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4">
          <p className="text-gray-700 dark:text-gray-300">
            L'oggetto <span className="font-semibold text-blue-600 dark:text-blue-400">{sourceOggettoName}</span> è 
            stato duplicato con successo come <span className="font-semibold text-green-600 dark:text-green-400">{targetOggettoName}</span>.
          </p>
          
          {attributesCount > 0 ? (
            <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 rounded-lg p-4">
              <p className="text-sm text-gray-700 dark:text-gray-300">
                Sono stati trovati <span className="font-semibold text-blue-600 dark:text-blue-400">{attributesCount} attributi</span> associati 
                all'oggetto originale.
              </p>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                Vuoi duplicare anche tutti gli attributi per il nuovo oggetto?
              </p>
            </div>
          ) : (
            <div className="bg-gray-50 dark:bg-gray-900/20 border border-gray-200 dark:border-gray-700 rounded-lg p-4">
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Nessun attributo trovato per l'oggetto originale.
              </p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex justify-end space-x-3 p-6 border-t border-gray-200 dark:border-gray-700">
          <button
            onClick={() => onConfirm(false)}
            disabled={isProcessing}
            className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors disabled:opacity-50"
          >
            No, solo l'oggetto
          </button>
          
          {attributesCount > 0 && (
            <button
              onClick={() => onConfirm(true)}
              disabled={isProcessing}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 rounded-md transition-colors disabled:opacity-50 flex items-center space-x-2"
            >
              {isProcessing ? (
                <>
                  <FaSpinner className="animate-spin h-4 w-4" />
                  <span>Duplicazione in corso...</span>
                </>
              ) : (
                <>
                  <FaCheck className="h-4 w-4" />
                  <span>Sì, duplica gli attributi</span>
                </>
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DuplicateAttributesModal;
